import CrossOrgDevicesPage from '@totem/components/administration/devices/CrossOrgDeviceManagement/CrossOrgDeviceManagementPage';
import CrossOrgRemoteAccessGatewaysPage from '@totem/components/administration/devices/RemoteAccessGateways/CrossOrgRemoteAccessGateways';
import DeviceEndOfSupportPage from '@totem/components/deviceEndOfSupport/deviceEndOfSupportPage';
import DeviceDetailsPage from '@totem/components/devices/deviceDetails/DeviceDetailsPage';
import DevicesPage from '@totem/components/devices/DevicesPage';
import SoftwareImportPage from '@totem/components/devices/software-import/SoftwareImportPage';
import DeviceSoftwareEndOfLifePage from '@totem/components/devices/softwareEndOfLife/summary/DeviceSoftwareEndOfLifePage';
import LayoutPage from '@totem/components/devices/variables/presentation/layout/LayoutPage';
import DeviceTypesPage from '@totem/components/deviceTypes/DeviceTypesPage';
import EndOfLifePage from '@totem/components/endoflife/EndOfLifePage';
import MaintenanceDetailsPage from '@totem/components/maintenanceWindows/detail/maintenanceDetailsPage';
import MaintenanceWindowsPage from '@totem/components/maintenanceWindows/maintenanceWindowsPage';
import MaintenanceWindowDetailV2Page from '@totem/components/maintenanceWindowsV2/detail/MaintenanceWindowDetailV2Page';
import MaintenanceWindowsV2Page from '@totem/components/maintenanceWindowsV2/MaintenanceWindowsV2Page';
import NetworkConcernsPage from '@totem/components/networkConcerns/networkConcernsPage';
import OSPatchReportPage from '@totem/components/osPatchReport/osPatchReportPage';
import NetworkPage from '@totem/components/portfolio/buildings/details/network/networkPage';
import AssetInventoryV2Page from '@totem/components/services/assetInventory/v2/AssetInventoryV2Page';
import DeviceBackups from '@totem/components/services/backup/deviceBackups/DeviceBackups';
import InternalBackupDashboardPage from '@totem/components/services/backup/internalDashboard/InternalBackupDashboardPage';
import UbiquitiHostDetailsPage from '@totem/components/ubiquiti/hosts/details/UbiquitiHostDetailsPage';
import UbiquitiHostsPage from '@totem/components/ubiquiti/hosts/List/UbiquitiHostsPage';
import UbiquitiSitesPage from '@totem/components/ubiquiti/sites/UbiquitiSitesPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import DeviceVulnerabilityReportPage from '@totem/components/vulnerabilities/report/vulnerabilityReportPage';
import { ContractedServices } from '@totem/types/contractedServices';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const deviceRoutes: Route[] = [
  {
    path: 'assetInventory',
    pageTitle: 'Asset Inventory',
    component: AssetInventoryV2Page,
    exact: true,
    breadcrumbs: [{ label: 'Asset Inventory' }],
    render: (userProfile: UserProfile) =>
      permissions.assetInventory.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'assetInventory2',
    pageTitle: 'Asset Inventory',
    component: AssetInventoryV2Page,
    exact: true,
    breadcrumbs: [{ label: 'Asset Inventory' }],
    render: (userProfile: UserProfile) =>
      permissions.assetInventory.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'devices',
    pageTitle: 'Devices',
    component: DevicesPage,
    exact: true,
    breadcrumbs: [{ label: 'Devices' }],
    render: (userProfile: UserProfile) =>
      permissions.devices.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'devices/:id',
    pageTitle: 'Device Detail',
    component: DeviceDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Devices', link: '/devices' },
      { label: 'Device Overview' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'devices/endOfSupport',
    pageTitle: 'Device End-of-Support',
    component: DeviceEndOfSupportPage,
    exact: true,
    breadcrumbs: [{ label: 'Device End-of-Support' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ) ||
      permissions.devices.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'devices/software/import',
    pageTitle: 'Software Inventory Import',
    component: SoftwareImportPage,
    exact: true,
    breadcrumbs: [
      { label: 'Devices', link: '/devices' },
      { label: 'Software Inventory Import' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.organizationalAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'devices/software/endOfSupport',
    pageTitle: 'Installed Software End-of-Support (Next 12 Months)',
    component: DeviceSoftwareEndOfLifePage,
    exact: true,
    breadcrumbs: [
      { label: 'Portfolio Overview', link: '/' },
      { label: 'Installed Software End-of-Support' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'networkConcerns',
    pageTitle: 'Network Concerns',
    component: NetworkConcernsPage,
    exact: true,
    breadcrumbs: [{ label: 'Network Concerns' }],
    render: (userProfile: UserProfile) =>
      permissions.internalRMM.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'deviceTypes',
    pageTitle: 'DeviceTypes',
    component: DeviceTypesPage,
    exact: true,
    breadcrumbs: [{ label: 'Device Types' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'osPatching',
    pageTitle: 'OS Patch Report',
    component: OSPatchReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Devices', link: '/devices' }],
    render: (userProfile: UserProfile) =>
      permissions.rmm.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'deviceVulnerabilities',
    pageTitle: 'Device Vulnerabilities',
    component: DeviceVulnerabilityReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Devices', link: '/devices' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'endoflife',
    pageTitle: 'Product End of Life',
    component: EndOfLifePage,
    exact: true,
    breadcrumbs: [{ label: 'Product End of Life' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'maintenanceWindows',
    pageTitle: 'Maintenance Windows',
    component: MaintenanceWindowsV2Page,
    exact: true,
    breadcrumbs: [{ label: 'Maintenance Windows' }],
    render: (userProfile: UserProfile) =>
      permissions.maintenanceWindowViewer.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  // New Maintenance Windows page; reachable by URL only (not in the menu) while it is reviewed in production.
  {
    path: 'maintenanceWindows2',
    pageTitle: 'Maintenance Windows',
    component: MaintenanceWindowsV2Page,
    exact: true,
    breadcrumbs: [{ label: 'Maintenance Windows' }],
    render: (userProfile: UserProfile) =>
      permissions.maintenanceWindowViewer.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'maintenanceWindows2/:id',
    pageTitle: 'Maintenance Window',
    component: MaintenanceWindowDetailV2Page,
    exact: true,
    breadcrumbs: [
      { label: 'Maintenance Windows', link: '/maintenanceWindows2' },
      { label: 'Maintenance Window' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.maintenanceWindowViewer.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'maintenanceWindows/:id',
    pageTitle: 'Maintenance Window',
    component: MaintenanceWindowDetailV2Page,
    exact: true,
    breadcrumbs: [
      { label: 'Maintenance Windows', link: '/maintenanceWindows' },
      { label: 'Maintenance Window' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'deviceBackups',
    pageTitle: 'Backup Summary',
    component: DeviceBackups,
    exact: true,
    breadcrumbs: [
      { label: 'Devices', link: '/devices' },
      { label: 'Backups', link: '/backups' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.continuity.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'backupDashboard',
    pageTitle: 'Backup Dashboard',
    component: InternalBackupDashboardPage,
    exact: true,
    breadcrumbs: [{ label: 'Backup Dashboard' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'adminGateways',
    pageTitle: 'All Gateways',
    component: CrossOrgRemoteAccessGatewaysPage,
    exact: true,
    breadcrumbs: [{ label: 'All Gateways' }],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'adminDevices',
    pageTitle: 'All Devices',
    component: CrossOrgDevicesPage,
    exact: true,
    breadcrumbs: [{ label: 'All Devices' }],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'network/:id',
    pageTitle: 'Building Network',
    component: NetworkPage,
    exact: true,
    breadcrumbs: [
      { label: 'Buildings', link: '/buildings' },
      { label: 'Building Overview' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'variable/layout/:id',
    pageTitle: 'Variables',
    component: LayoutPage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'ubiquiti/hosts',
    pageTitle: 'Ubiquiti Hosts',
    component: UbiquitiHostsPage,
    exact: true,
    breadcrumbs: [],
    render: (
      userProfile: UserProfile,
      contractedServices?: ContractedServices,
    ) =>
      permissions.uniFiService.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
        contractedServices,
      ),
  },
  {
    path: 'ubiquiti/hosts/:id',
    pageTitle: 'Ubiquiti Host Details',
    component: UbiquitiHostDetailsPage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'ubiquiti/sites',
    pageTitle: 'Ubiquiti Sites',
    component: UbiquitiSitesPage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
